import React, { useEffect, useRef } from 'react';
import { usePowermailSettings } from '../../context/PowermailContext';
export const Content = ({ field }) => {
    const powermailSettings = usePowermailSettings();
    const ref = useRef(null);
    useEffect(() => {
        if (!ref.current) {
            return;
        }
        const element = document.getElementById(`content_${field.uid}`);
        if (element === null || element === void 0 ? void 0 : element.firstChild) {
            ref.current.replaceChildren(element.firstChild.cloneNode(true));
        }
    }, []);
    return (React.createElement("div", { className: `powermail_fieldwrap powermail_fieldwrap_type_content no-indentation powermail_fieldwrap_${field.marker} ${field.css} ${powermailSettings.fieldAndLabelWrappingClasses}` },
        React.createElement("div", { className: `${powermailSettings.fieldWrappingClasses} ${powermailSettings.offsetClasses}`, ref: ref })));
};
